export default "__VITE_ASSET__CkTXL$Lw__"